module.exports = __webpack_public_path__ + "img/rupesh.0617b6bc.png";